var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKebabMenuIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4,
    height: 12,
    viewBox: "0 0 4 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.0013 2.66667C2.7373 2.66667 3.33464 2.06933 3.33464 1.33333C3.33464 0.597333 2.7373 0 2.0013 0C1.2653 0 0.667969 0.597333 0.667969 1.33333C0.667969 2.06933 1.2653 2.66667 2.0013 2.66667ZM2.0013 4.66667C1.2653 4.66667 0.667969 5.264 0.667969 6C0.667969 6.736 1.2653 7.33333 2.0013 7.33333C2.7373 7.33333 3.33464 6.736 3.33464 6C3.33464 5.264 2.7373 4.66667 2.0013 4.66667ZM0.667969 10.6667C0.667969 9.93067 1.2653 9.33333 2.0013 9.33333C2.7373 9.33333 3.33464 9.93067 3.33464 10.6667C3.33464 11.4027 2.7373 12 2.0013 12C1.2653 12 0.667969 11.4027 0.667969 10.6667Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1405_9804",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 4,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.0013 2.66667C2.7373 2.66667 3.33464 2.06933 3.33464 1.33333C3.33464 0.597333 2.7373 0 2.0013 0C1.2653 0 0.667969 0.597333 0.667969 1.33333C0.667969 2.06933 1.2653 2.66667 2.0013 2.66667ZM2.0013 4.66667C1.2653 4.66667 0.667969 5.264 0.667969 6C0.667969 6.736 1.2653 7.33333 2.0013 7.33333C2.7373 7.33333 3.33464 6.736 3.33464 6C3.33464 5.264 2.7373 4.66667 2.0013 4.66667ZM0.667969 10.6667C0.667969 9.93067 1.2653 9.33333 2.0013 9.33333C2.7373 9.33333 3.33464 9.93067 3.33464 10.6667C3.33464 11.4027 2.7373 12 2.0013 12C1.2653 12 0.667969 11.4027 0.667969 10.6667Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1405_9804)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -6,
    y: -2,
    width: 16,
    height: 16,
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKebabMenuIcon);
export default __webpack_public_path__ + "static/media/KebabMenuIcon.b9ad3c49a17e6a6578ba0a9a1fa2998b.svg";
export { ForwardRef as ReactComponent };